<template>
  <div class="logistics-list">
    <div class="search-add">
      <div class="search">
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="客户列表：" prop="customerId">
            <el-select
              v-model="form.customerId"
              filterable
              clearable
              class="gray"
              placeholder="请选择"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递类型：" prop="logisticsType">
            <el-select
              v-model="form.logisticsType"
              filterable
              clearable
              class="gray"
              placeholder="请选择"
            >
              <el-option
                v-for="item in logisticsList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="16px">
            <el-button class="btn-blue" @click="screenData">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="add">
        <el-button class="btn-blue" @click="toAddLogistics">添加规则</el-button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="customerName" label="客户"></el-table-column>
        <el-table-column prop="expressName" label="快递"></el-table-column>
        <el-table-column
          prop="expressMethodName"
          label="计费类型"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              :class="
                scope.row.expressMethod === 2 ? 'btn-text disab' : 'btn-text'
              "
              :disabled="scope.row.expressMethod === 2"
              type="text"
              @click="toLogisticsDetail(scope.row)"
              >详情</el-button
            >
            <el-button
              :class="
                scope.row.expressMethod === 2 ? 'btn-text disab' : 'btn-text'
              "
              type="text"
              :disabled="scope.row.expressMethod === 2"
              @click="
                toModLogistics(scope.row.customerId, scope.row.expressType, scope.row.expressMethod)
              "
              >编辑</el-button
            >
            <el-button
              class="btn-text"
              type="text"
              @click="
                deleteLogistics(scope.row.customerId, scope.row.expressType)
              "
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增客户规制 -->
    <el-dialog title="新增规制" top="35vh" :visible.sync="addLogisticsRuleDialog" width="420px">
      <div class="border"></div>
      <el-form
        ref="logisticsForm"
        :rules="logisticsFormRules"
        :model="logisticsForm"
        label-width="80px"
      >
        <el-form-item label="客户列表：" prop="customerId">
          <el-select
            v-model="logisticsForm.customerId"
            class="gray"
            placeholder="请选择"
          >
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递类型：" prop="logisticsType">
          <el-select
            v-model="logisticsForm.logisticsType"
            class="gray"
            placeholder="请选择"
          >
            <el-option
              v-for="item in logisticsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计费类型：" prop="expressMethod">
          <el-select
            v-model="logisticsForm.expressMethod"
            class="gray"
            placeholder="请选择"
          >
            <el-option
              v-for="item in expressList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="submit('logisticsForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Logistics from "models/logistics";
const logistics = new Logistics();
import { modifyNetTitle } from "common/js/util";
export default {
  data() {
    return {
      form: {
        customerId: "",
        logisticsType: ""
      },
      logisticsForm: {
        customerId: "",
        logisticsType: "",
        expressMethod: "",
      },
      logisticsFormRules: {
        customerId: {
          required: true,
          message: "请选择客户",
          trigger: "change",
        },
        logisticsType: {
          required: true,
          message: "请选择快递",
          trigger: "change",
        },
        expressMethod: {
          required: true,
          message: "请选择计费类型",
          trigger: "change",
        },
      },
      expressList: [
        {
          id: 1,
          name: "计重",
        },
        {
          id: 2,
          name: "现场定价",
        },
        {
          id: 3,
          name: "计体积",
        },
      ],
      expressObj: {
        1: '计重',
        2: '现场定价',
        3: '计体积'
      },
      customerList: [],
      logisticsList: [],
      tableData: [],
      addLogisticsRuleDialog: false
    };
  },
  created() {
    modifyNetTitle('客户快递规则列表')
    this.getCustomerList();
    this.getLogisticsList();
    this.customerExpressList();
  },
  methods: {
    //获取客户列表
    getCustomerList() {
      logistics.getCustomerData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
        }
      });
    },
    //获取客户快递列表
    customerExpressList() {
      let customerId = this.form.customerId;
      let expressType = this.form.logisticsType;
      logistics.getCustomerExpressList(customerId, expressType).then(res => {
        if (res.success) {
          let tableData = [];
          res.result.map(value => {
            let obj = {};
            obj.customerId = value.customerId;
            obj.customerName = value.ordersName;
            obj.expressType = value.expressType;
            obj.expressName = value.expressName;
            obj.expressMethod = value.expressMethod;
            obj.expressMethodName = this.expressObj[value.expressMethod]
            tableData.push(obj);
          });
          this.tableData = tableData;
        }
      });
    },
    /* 获取快递列表 */
    getLogisticsList() {
      logistics.getExpressData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.logisticsList = arr;
        }
      });
    },
    //筛选数据
    screenData() {
      this.customerExpressList();
    },
    //前往添加规则
    toModLogistics(id, type, expressMethod) {
      if (id && type) {
        this.$router.push({
          path: "/base-info/carrier/logistics/add-logistics",
          query: {
            id,
            type,
            isUpdate: 1,
            expressMethod
          }
        });
      }
    },
    toAddLogistics() {
      this.addLogisticsRuleDialog = true
    },
    //前往详情页
    toLogisticsDetail(row) {
      let id = row.customerId;
      let name = row.customerName;
      let type = row.expressType;
      let expressName = row.expressName;
      this.$router.push({
        path: "/base-info/carrier/logistics/logistics-detail",
        query: {
          id,
          name,
          type,
          expressName
        }
      });
    },
    deleteLogistics(id, type) {
      this.$confirm("确定删除该数据, 是否继续?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let data = {};
          data.customerId = id;
          data.expressType = type;
          logistics.postDeleteExpressRule(data).then(res => {
            if (res.success) {
              this.$message.success("删除成功");
              this.customerExpressList();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },
    closeDialog() {
      this.$refs["logisticsForm"].resetFields();
      this.addLogisticsRuleDialog = false
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let id = this.logisticsForm.customerId
          let type = this.logisticsForm.logisticsType
          let expressMethod = this.logisticsForm.expressMethod
          let data = {
            customerId: id,
            expressType: type,
            expressMethod
          }
          logistics.postAddBaseInfo(data).then(res => {
            if (res.success) {
              if (expressMethod != 2) {
                this.$router.push({
                  path: "/base-info/carrier/logistics/add-logistics",
                  query: {
                    id,
                    type,
                    expressMethod,
                    isUpdate: 0
                  }
                });
              } else {
                this.closeDialog()
                this.customerExpressList()
              }
            } else {
              this.$message.error(res.message)
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.logistics-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  .search-add {
    padding: 16px;
    padding-bottom: 0;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    .search {
      .el-form {
        display: flex;
      }
    }
  }
  .table {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    .disab {
      color: #aaa;
    }
  }
  .el-dialog {
    .el-form {
      .el-form-item__content {
        height: 32px;
        display: flex;
        align-items: center;
        .el-select {
          width: 100%;
        }
      }
    }
    .dialog-footer {
      margin-top: 16px;
      border-top: 1px solid #f7f7f7;
      padding-top: 16px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
